export enum EventStatus {
  Created = 1,
  Audited = 2,
  Approved = 3,
  SentForAuditing = 4,
  Rejected = 5,
  PendingForApproval = 6,
  Published = 7,
}
